"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Date = void 0;
const react_1 = __importDefault(require("react"));
const luxon_1 = require("luxon");
const Date = (props) => {
    const dt = luxon_1.DateTime.fromISO(props.isoDate);
    const s = props.format ? dt.toFormat(props.format) : dt.toRelative();
    return react_1.default.createElement(react_1.default.Fragment, null, s);
};
exports.Date = Date;
//# sourceMappingURL=index.js.map